import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignVerticalSpaceBetween: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '5', y: '15', width: '14', height: '6', rx: '2' }],
    ['rect', { x: '7', y: '3', width: '10', height: '6', rx: '2' }],
    ['path', { d: 'M2 21h20' }],
    ['path', { d: 'M2 3h20' }],
  ],
];

export default AlignVerticalSpaceBetween;
